import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SupplierService } from './supplier.service';
import { Supplier } from './product.types';
import { Observable } from 'rxjs/Observable';
import { StaticService } from '../core/static.service';
import { Country, FormalityScale, Language } from '../core/core.types';

@Component({
  template: `
    <b4a-product-supplier-form
      [supplier]="supplier"
      [countries]="countries"
      [languages]="languages"
      [onSubmit]="onSubmit.bind(this)"
    ></b4a-product-supplier-form>`
})
export class SupplierDetailPageComponent implements OnInit {

  supplier: Supplier;

  countries: Country[];

  formalityScales: FormalityScale[];

  languages: Language[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private supplierService: SupplierService,
    private staticService: StaticService
  ) {}

  ngOnInit() {
    this.route.params
      .switchMap((params: Params) => {
        if (params.id === 'new') {
          return Observable.of(this.supplierService.getSupplierSkeleton());
        } else {
          return this.supplierService.getSupplier(+params.id);
        }
      })
      .subscribe((supplier) => this.supplier = supplier);

    this.staticService.getFormalityScales()
      .subscribe(data => this.formalityScales = data);

    this.staticService.getLanguages()
      .subscribe(data => this.languages = data);

    this.staticService.getCountries()
      .subscribe(data => this.countries = data);
  }

  //save za products/suppliers/id
  public onSubmit() {
    this.supplierService.saveSupplier(this.supplier)
      .subscribe((supplier: Supplier) => {
        this.router.navigate(['/products/suppliers']);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/product/supplier-detail-page.container.ts